export const queryUrls = {
  authApi: {
    registration: 'register/',
    login: 'token/',
    logout: 'logout/',
    emailVerify: 'email-verify',
    /* слеши для emailVerify расписаны внутри query,
    тк в составе динамические параметры */
    refresh: 'token/refresh/',
    forgotPassword: 'forgot-password/',
    resetPassword: 'password-reset-confirm',
    /* слеши для resetPassword расписаны внутри query,
    тк в составе динамические параметры */
    changePassword: 'change-password/',
  },
  userApi: {
    getProfile: 'profile/',
    updateProfile: 'profile/',
  },
  debateApi: {
    getAllDebates: 'debate/',
    getMyDebates: 'profile/debates/',
    cancelDebate: '/cancel/', // дополнительная часть url идет с двумя слешами
    checkDebateUser: '/entry/',
    endDebate: '/leave/',
  },
  challengeApi: {
    getAllChallenges: 'challenge/',
    createChallenge: 'challenge/',
    setOpponent: '/set_opponent/', // дополнительная часть url идет с двумя слешами
    cancelChallenge: '/cancel/',
    getMyChallenges: 'profile/challenges/',
  },
  topicsApi: {
    generateTopics: 'generate_topic/',
  },
};
